import {userService} from "../services/UserService";
import {useNavigate} from "react-router-dom";

export default function HeaderLogout(props){

    const navigation = useNavigate();

    function logoutSubmit(){
        userService.Logout();
        navigation('/login');
    }

    return (
        <a href="#" onClick={logoutSubmit}><i data-feather="log-in"> </i><span>Выход</span></a>
    );
}